module.exports = __webpack_public_path__ + "img/6_1.3f23446e.jpg";